import { useEffect, useState } from 'react';

const ProfileAvatar = ({firstName, lastName }:any) => {
  const getRandomColor = () => {
    const colors = ['#837171', '#5b5b85', '#479d89'];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const [initials, setInitials] = useState('');
  const [randomColor, setRandomColor] = useState('');

  useEffect(() => {
    console.log(firstName,'nj',lastName);
    
    if(firstName&&lastName){
      setInitials(`${firstName?.toUpperCase().charAt(0)}${lastName?.toUpperCase().charAt(0)}`);
    }else if(firstName){
      setInitials(`${firstName?.toUpperCase().charAt(0)}${firstName?.toUpperCase().charAt(0)}`);
    }
    setRandomColor(getRandomColor());
  }, [firstName, lastName]);
      
    return (
      <div
        style={{
          width: '52px',
          height: '52px',
          borderRadius: '50%',
          backgroundColor: randomColor,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '1.5rem',
        }}
      >
        {initials}
      </div>
    );

};

export default ProfileAvatar;